import { useRecoilValue } from 'recoil';

import { productItemState } from '../../store/product/atom';

export const useIsSellingOrRescuing = () => {
  const selectedProduct = useRecoilValue(productItemState).current;

  const { operationType } = selectedProduct;

  const isSellingOrRescuing = operationType === 'sell';

  return isSellingOrRescuing;
};
